import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from '../../../api.service';
import { AgGridAngular } from 'ag-grid-angular';
import { ExcelService } from 'src/app/excel.service';
type AOA = any[][];
@Component({
  selector: 'app-excelexport',
  templateUrl: './excelexport.component.html',
  styleUrls: ['./excelexport.component.css']
})
export class ExcelexportComponent implements OnInit {

  @ViewChild('fileControl') fileControl: ElementRef;
  timeLeft: number = 0;
  interval;
  data: AOA = [];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'SheetJS.xlsx';
  file: any;
  arrayBuffer: any;
  Last_existing_count = 0;
 
  excel_data = [];
  loader_status = false;

  user_details : any = [];
  portfolio_details : any = [];
  bank_details : any = [];
  product_details :  any = [];



  constructor(
    private _api: ApiService,
    private excelService: ExcelService,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) { }

  ngOnInit(): void {

    let a = {
      limit: 50000,
      skip : 0
    }
    this._api.listing_customer_datas(a).subscribe(
      (response: any) => {
        console.log(response.Data.length);
        this.excel_data = response.Data;
      
      }
    );

    this._api.user_details_list().subscribe(
      (response: any) => {
        this.user_details = response.Data;
      }
    );

  
    var c = {
      client_id: this.getFromLocal("Client_ID")
    };

    this._api.getlist_bank_detail(c).subscribe(
      (response: any) => {
        this.bank_details = response.Data;
      }
    );

    this._api.portfolio_type_list(c).subscribe(
      (response: any) => {
        this.portfolio_details = response.Data;
      }
    );

    this._api.product_type_list(c).subscribe(
      (response: any) => {
        this.product_details = response.Data;
      }
    );

  }


  start_lopp(){
   
    for(let a = 0 ; a < this.excel_data.length; a ++){

      this.excel_data[a].user_email = "N/A";
      this.excel_data[a].bank_name = "N/A";
      this.excel_data[a].product_name = "N/A";
      this.excel_data[a].porfilo_name = "N/A";
      for(let c = 0 ; c < this.user_details.length ; c ++){
        if(this.excel_data[a].added_by == ""+this.user_details[c]._id){
          this.excel_data[a].user_email = this.user_details[c].email_id;
        }

      }

      for(let d = 0 ; d < this.bank_details.length ; d ++){
        if(this.excel_data[a].bank_id == ""+this.bank_details[d]._id){
          this.excel_data[a].bank_name = this.bank_details[d].bank_name;
        }
        
      }
      for(let e = 0 ; e < this.product_details.length ; e ++){
        if(this.excel_data[a].product_id == ""+this.product_details[e]._id){
          this.excel_data[a].product_name = this.product_details[e].product_type;
        }
        
      }
      for(let f = 0 ; f < this.portfolio_details.length ; f ++){

        if(this.excel_data[a].porfolio_id == ""+this.portfolio_details[f]._id){
          this.excel_data[a].porfilo_name = this.portfolio_details[f].portfolio_type;
        }
        
      }
    




   if(a == this.excel_data.length - 1){
     console.log(this.excel_data);
   }



    }



    
  }
  

  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }



  onFileChange(event){ 
    this.excel_data = [];  
    this.file= event.target.files[0];     
    let fileReader = new FileReader();    
    fileReader.readAsArrayBuffer(this.file);     
    fileReader.onload = (e) => {    
        this.arrayBuffer = fileReader.result;    
        var data = new Uint8Array(this.arrayBuffer);    
        var arr = new Array();    
        for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);    
        var bstr = arr.join("");    
        var workbook = XLSX.read(bstr, {type:"binary"});    
        var first_sheet_name = workbook.SheetNames[0];    
        var worksheet = workbook.Sheets[first_sheet_name];    
        console.log(XLSX.utils.sheet_to_json(worksheet,{raw:true}));    
          var arraylist = XLSX.utils.sheet_to_json(worksheet,{raw:true});     
              this.excel_data = arraylist;    
              console.log(arraylist)    
}
}








  closeExcel() {
    this.fileControl.nativeElement.value = null;
  }


 


  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.excel_data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }


  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.excel_data,'Fint_Gen');
  }

}

